var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import 'emoji-mart/css/emoji-mart.css';
import { Picker } from 'emoji-mart';
import React from 'react';
import { calculateShowLeft } from '../utils';
var PICKER_WIDTH = 340;
var EmojiPicker = /** @class */ (function (_super) {
    __extends(EmojiPicker, _super);
    function EmojiPicker(props) {
        var _this = _super.call(this, props) || this;
        _this.picker = null;
        _this.$btn = null;
        _this.state = {
            open: false,
            marginLeft: 0,
        };
        _this.bindEvent = function () { return document.addEventListener('click', _this.listenClickEvent, true); };
        _this.unBindEvent = function () { return document.removeEventListener('click', _this.listenClickEvent, true); };
        _this.selectEmoji = function (emoji) {
            _this.props.editor.insertText(emoji.native);
            _this.hide();
        };
        _this.listenClickEvent = function (e) {
            if (_this.$btn && _this.$btn.contains(e.target))
                return;
            if (_this.state.open && _this.picker && !_this.picker.contains(e.target)) {
                requestAnimationFrame(function () { return _this.hide(); });
            }
        };
        _this.open = function () {
            _this.fixPos();
            _this.setState({
                open: true,
            });
            _this.bindEvent();
        };
        _this.hide = function () {
            _this.setState({
                open: false,
            });
            _this.unBindEvent();
        };
        _this.toggleVisible = function () { return (_this.state.open ? _this.hide() : _this.open()); };
        _this.$btn = props.mountDOM.querySelector('.syl-toolbar-button');
        return _this;
    }
    EmojiPicker.prototype.componentDidMount = function () {
        this.$btn && this.$btn.addEventListener('click', this.toggleVisible);
    };
    EmojiPicker.prototype.componentWillMount = function () {
        this.$btn && this.$btn.removeEventListener('click', this.toggleVisible);
    };
    EmojiPicker.prototype.fixPos = function () {
        var mountDOM = this.props.mountDOM;
        if (!mountDOM || !this.picker || !this.picker.parentElement)
            return;
        this.setState({
            marginLeft: calculateShowLeft(this.picker, mountDOM),
        });
    };
    EmojiPicker.prototype.render = function () {
        var _this = this;
        var _a = this.state, open = _a.open, marginLeft = _a.marginLeft;
        var backgroundImageFn = this.props.backgroundImageFn;
        return (React.createElement("div", { className: "syl-emoji-picker-container", ref: function (el) {
                if (el) {
                    _this.picker = el;
                }
            }, style: __assign({ position: 'absolute', visibility: open ? 'visible' : 'hidden', zIndex: 2 }, (marginLeft ? { marginLeft: marginLeft } : {})) },
            React.createElement(Picker, { set: "messenger", backgroundImageFn: backgroundImageFn ? backgroundImageFn : undefined, onSelect: this.selectEmoji, style: { width: PICKER_WIDTH } })));
    };
    return EmojiPicker;
}(React.Component));
export { EmojiPicker };
//# sourceMappingURL=index.js.map